export const dischargedMembers = 'discharged-members';
export const dischargedMember = 'discharged-member';
